module.exports = __webpack_public_path__ + "static/media/google_play_button.5bc62025.png";